import { SearchRequestInstrumentation } from 'owa-search-service';
import { PerformanceDatapoint, CalculatedResourceTimings } from 'owa-analytics';
import { action } from 'satcheljs';

export const addResourceTimingEntry = action(
    '__DIAGNOSTICS_SEARCH_ADD_RESOURCE_TIMING_ENTRY',
    (
        resourceTimingEntry: CalculatedResourceTimings,
        searchInstrumentationEntry: SearchRequestInstrumentation,
        executeSearchDatapoint: PerformanceDatapoint
    ) => ({ resourceTimingEntry, searchInstrumentationEntry, executeSearchDatapoint })
);
